// Vue, third party
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { TaskLibrary, TaskCategory, ActionTrigger, TaskType } from "@/store/tasks/types";

// Namespaces
const Tasks = namespace("tasks");

/**
 * Mixin which adds helper and default methods to action components.
 */
@Component({})
export default class ActionMixin extends Vue {

    @Tasks.State(state =>  state.TaskCategories) taskCategories: TaskCategory[];
    @Tasks.State(state => state.TaskLibrary) taskLibrary: TaskLibrary[];
    @Tasks.State(state => state.TaskTypes) taskTypes: TaskType[];
    @Tasks.Getter getActionById: (actionId: number) => TaskLibrary;
    @Tasks.State taskTriggers: ActionTrigger[];

    /**
     * @summary Method to get the TaskText and if couldn't be parsed correctly, gets the action type.
     * @param actionId the desired actionId
     * @return will return the text of taskText or the type.
     */
    public getTaskTextOrType(actionId: number): string | null {
        const action: TaskLibrary = this.getActionById(actionId);
        if (!action || (action && !action.taskText || action.taskText == "")) {
           const type: TaskType = this.getTaskTypeById(action.taskTypeID);
           if (!type) return "Unknown";
           return type.title;
        }
        return action.taskText;
    }

    /**
     * @summary Method to get the taskType using the taskTypeId
     * @param taskTypeId the desired taskTypeId
     * @return will return the taskType object or null if not found.
     */
    public getTaskTypeById(taskTypeId: number): TaskType | null {
        const type: TaskType = this.taskTypes.find((type: TaskType) => type.taskTypeID == taskTypeId);
        return type ?? null;
    }

    /**
     * @summary Method to get the triggerAction by task id
     * @param actionId desired actionId
     * @return will return taskTrigger object or null if not found
     */
    public getTaskTriggerByActionId(actionId: number): ActionTrigger | null  {
        const actionTrigger: ActionTrigger = this.taskTriggers.find(
            (trigger: ActionTrigger) => trigger.taskID == actionId);
        return actionTrigger ?? null;
    }

    /**
     * @summary method to get the action trigger by tasktriggerID
     * @param actionTriggerId
     */
    public getActionTriggerByActionTriggerId(actionTriggerId: number): ActionTrigger | null  {
        const actionTrigger: ActionTrigger = this.taskTriggers.find(
            (trigger: ActionTrigger) => trigger.triggerTaskID == actionTriggerId);
        return actionTrigger ?? null;
    }

    /**
     * @summary Method to get the catrgory for a action.
     * @param actionId the actionId used to find the linked category.
     * @return will return the desired category or null if the action or category was not found.
     */
    public getCategoryByAction(actionId: number): TaskCategory | null {
        const action: TaskLibrary = this.getActionById(actionId);
        if (!action) return null;
        const taskCategory: TaskCategory = this.taskCategories.find(
            (category: TaskCategory) => category.taskCategoryID == action.taskCategoryID);
        return taskCategory ?? null;
    }
}